import { render, staticRenderFns } from "./thread-child-comment.vue?vue&type=template&id=f11729c6&scoped=true"
import script from "./thread-child-comment.vue?vue&type=script&lang=js"
export * from "./thread-child-comment.vue?vue&type=script&lang=js"
import style0 from "./thread-child-comment.vue?vue&type=style&index=0&id=f11729c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11729c6",
  null
  
)

export default component.exports